import { useContext } from 'react';
import { GroupFeaturesContext } from '@trinity/chat-components/containers/Chat';

export const useIsSmartRouting = () => {
  const features = useContext(GroupFeaturesContext);
  return features.smartRouting;
};